import React,{useEffect} from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import Header from '../Header';
import Breadcrumb from './Breadcrumb';
import Sidebar from './Sidebar';
import Footer from '../Footer';

const ProfilePage = () => {
  const location = useLocation();
  const params = useParams();
  useEffect(() => {
        window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
      }, []);

  const getBreadcrumbItems = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const baseItems = ['Home', 'Profile'];

    if (pathSegments.length > 1) {
      const lastSegment = pathSegments[pathSegments.length - 1];
      const secondLastSegment = pathSegments[pathSegments.length - 2];
      const thirdLastSegment = pathSegments[pathSegments.length - 3];

      const pageNames = {
        'orders': 'Orders',
        // 'purchases': 'Purchases',
        'subscription': 'Subscription Plan',
        'subscriptionhistory': 'Subscriptions History',
        'address': 'My Address',
        'settings': 'Settings',
        'share': 'Share App'
      };

      // Check if we're on a repeat order page
      if (lastSegment === 'repeat' && secondLastSegment && thirdLastSegment === 'orders') {
        baseItems.push('Orders');
        baseItems.push(`#${secondLastSegment}`);
        baseItems.push('Repeat Order');
      }
      // Check if we're on an order details page
      else if (secondLastSegment === 'orders' && params.orderId) {
        baseItems.push('Orders');
        baseItems.push(`#${params.orderId}`);
      }
      // Check if we're on a purchase details page
      else if (secondLastSegment === 'purchases' && params.purchaseId) {
        baseItems.push('Purchases');
        baseItems.push(`#${params.purchaseId}`);
      } else if (pageNames[lastSegment]) {
        baseItems.push(pageNames[lastSegment]);
      }
    }

    return baseItems;
  };

  return (
    <div>
      <Header />
      <div className="flex overflow-hidden flex-col items-center pb-10 bg-neutral-50 max-md:pb-24">
        <Breadcrumb navigationItems={getBreadcrumbItems()} />

        <div className="mt-7 w-full max-w-[1140px] max-md:max-w-full max-md:px-4">
          <div className="flex gap-5 max-md:flex-col max-md:items-center">
            <Sidebar />
            <Outlet />
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default ProfilePage;
